<ng-container *ngIf="level">
  <div class="d-flex flex-column align-items-center">
    <div class="crowd-meter" id="crowdMeter{{ level }}"></div>
    <div class="crowd-meter-label">Crowd Meter</div>
  </div>
</ng-container>
